const fader = document.getElementById('js-fall-fader');
const gradient = document.getElementById('js-map-gradient');

if (fader && gradient) {

    fader.addEventListener('input', function repositionGradient() {

        const val = fader.value;

        /*
            use fader value to calculate the correct value for
            the map gradient's 'top' style

            these are the 'top' values we
            need to animate between:

                0: -900%
                10: -800%
                20: -774%
                30: -729%
                40: -702%
                50: -657%
                60: -639%
                70: -594%
                80: -594%
                90: -522%
                100: -522%
        */

        let gradientTop = -900;

        if (val <= 10) {

            gradientTop = 100 - ((100 - val) * 10);

        } else if (val <= 20) {

            gradientTop = 0 - 800 + ((val - 10) * 2.6);

        } else if (val <= 30) {

            gradientTop = 0 - 774 + ((val - 20) * 4.5);

        } else if (val <= 40) {

            gradientTop = 0 - 729 + ((val - 30) * 2.7);

        } else if (val <= 50) {

            gradientTop = 0 - 702 + ((val - 40) * 4.5);

        } else if (val <= 60) {

            gradientTop = 0 - 657 + ((val - 50) * 1.8);

        } else if (val <= 70) {

            gradientTop = 0 - 639 + ((val - 60) * 4.5);

        } else if (val <= 80) {

            gradientTop = -594;

        } else if (val <= 90) {

            gradientTop = 0 - 594 + ((val - 80) * 7.2);

        } else {

            gradientTop = -522;

        }

        gradient.style.top = gradientTop + '%';

    });

}

/*
*/
